import React from "react";
import PropTypes from "prop-types";

const findCountryByCountryId = (data, id) => {
  const countryObject = data.find(country => country.country_id === id);
  return countryObject.country_name;
};

const TabTitle = ({ data, currentTab, selectedCountry }) => {
  if (currentTab === "oda" && selectedCountry === "all") {
    return <div>Financing</div>;
  }
  else if (selectedCountry !== "all") {
    return <div>{findCountryByCountryId(data, selectedCountry)}</div>;
  }
  return null;
};

export default TabTitle;

TabTitle.propTypes = {
  currentTab: PropTypes.string.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
